// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./bg-img-2.jpg");
var dir = previousRequest.replace("bg-img-2.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "bg-img-2.jpg",
	name: "bg-img-2",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/bg-img-2.jpg
// module id = 988
// module chunks = 4